<template>
  <b-modal
    :id="modalId"
    v-model="isVisible"
    title=""
    size="md"
    centered
    hide-footer
    no-close-on-esc
    no-close-on-backdrop
    content-class="topup-success-modal-content"
  >
    <div class="topup-success-wrapper">
      <div class="d-flex align-items-center justify-content-center position-relative pb-1 border-bottom">
        <h3 class="mb-0 topup-success-title">
          Top Up Berhasil
        </h3>
      </div>

      <div class="d-flex align-items-center justify-content-between py-1 border-bottom topup-success-section-title">
        <span>Detail Transaksi</span>
        <span>Kredit Komed</span>
      </div>

      <div class="d-flex align-items-center justify-content-between py-1 topup-success-row">
        <span class="text-muted">Tanggal Top Up</span>
        <span class="font-weight-medium">{{ formattedTopupDate }}</span>
      </div>
      <div class="d-flex align-items-center justify-content-between py-1 topup-success-row">
        <span class="text-muted">ID Transaksi</span>
        <span class="font-weight-medium">{{ transaction.transactionId || '-' }}</span>
      </div>
      <div class="d-flex align-items-center justify-content-between py-1 topup-success-row">
        <span class="text-muted">Email</span>
        <span class="font-weight-medium">{{ transaction.email || '-' }}</span>
      </div>
      <div class="d-flex align-items-center justify-content-between py-1 border-bottom topup-success-row">
        <span class="text-muted">Nominal Top Up</span>
        <span class="font-weight-medium">{{ formatCurrencyRP(transaction.nominal) }}</span>
      </div>

      <div class="d-flex align-items-center justify-content-between py-1 mt-25 topup-success-total">
        <span>Total Dibayarkan</span>
        <span>{{ formatCurrencyRP(transaction.nominal) }}</span>
      </div>

      <div class="d-flex mt-2">
        <div class="flex-fill pr-50">
          <b-button
            variant="outline-secondary"
            block
            :disabled="isDownloading"
            @click="downloadReceipt"
          >
            <b-spinner
              v-if="isDownloading"
              small
              class="mr-50"
            />
            {{ isDownloading ? 'Mengunduh...' : 'Download Bukti Transaksi' }}
          </b-button>
        </div>
        <div class="flex-fill pl-50">
          <b-button
            variant="primary"
            block
            @click="handleRedirectHistory"
          >
            Riwayat Top Up
          </b-button>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
import { newAxiosIns } from '@/libs/axios'

export default {
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    modalId: {
      type: String,
      default: 'modal-topup-komed-success',
    },
    transaction: {
      type: Object,
      default: () => ({
        transactionId: null,
        email: null,
        nominal: 0,
        timestamp: null,
      }),
    },
  },
  data() {
    return {
      isDownloading: false,
    }
  },
  computed: {
    isVisible: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
    formattedTopupDate() {
      if (!this.transaction?.timestamp) return '-'

      const date = new Date(this.transaction.timestamp)
      return `${date.toLocaleString('id-ID', {
        year: 'numeric',
        month: 'long',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        hour12: false,
      }).replace(/\./g, ':').replace(/,/g, ' •')} WIB`
    },
  },
  methods: {
    formatCurrencyRP(value) {
      return `Rp${Number(value || 0).toLocaleString('id-ID')}`
    },
    handleClose() {
      this.$emit('close')
      this.$emit('input', false)
    },
    async downloadReceipt() {
      if (!this.transaction?.transactionId) {
        this.$toast_error({ message: 'ID transaksi tidak ditemukan' })
        return
      }

      this.isDownloading = true
      try {
        const response = await newAxiosIns.get(`/komed/api/v1/komed/topup/${this.transaction.transactionId}/receipt`,
          { responseType: 'blob' })
        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', `receipt-${this.transaction.transactionId}.pdf`)
        document.body.appendChild(link)
        link.click()
        link.remove()
        window.URL.revokeObjectURL(url)

        this.$toast_success({ message: 'Bukti transaksi berhasil diunduh' })
      } catch (error) {
        const message = error?.response?.data?.message || 'Gagal mengunduh bukti transaksi'
        this.$toast_error({ message })
      } finally {
        this.isDownloading = false
      }
    },
    handleRedirectHistory() {
      this.$router.push({ path: '/keuangan/saldo/detail' })
    },
  },
}
</script>

<style scoped>
.close-btn {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  padding: 0;
}

.topup-success-wrapper {
  font-size: 14px;
}

.topup-success-title {
  font-weight: 600;
  font-size: 21px;
  line-height: 1.2;
}

.topup-success-close {
  position: absolute;
  right: 0;
  top: -4px;
}

.topup-success-section-title {
  font-size: 16px;
  font-weight: 600;
}

.topup-success-row {
  font-size: 15px;
}

.topup-success-total {
  font-size: 16px;
  font-weight: 600;
}
</style>

<style>
.topup-success-modal-content {
  border-radius: 12px !important;
}

.topup-success-modal-content .modal-body {
  padding: 0 32px 32px !important;
}
</style>
